import { Fragment, useEffect } from "react";
import WarningBanner from "../WarningBanner";
import useGetIcdMismatch from "../../../services/utils/custom hooks/OnlineOrder/useGetIcdMismatch";
import toastMessages from "../../../services/utils/helpers/toastMessage";

interface IcdMismatchBannerProps {
  values: any;
  setFieldValue: any;
}

function IcdMismatchBanner({
  values,
  setFieldValue,
}: Readonly<IcdMismatchBannerProps>): JSX.Element {
  const icdCodes = [
    values.billingInfo.icdCodeId,
    ...values.additionalCodes,
  ].map(Number);

  const { data: icd10CodeMismatch, refetch } = useGetIcdMismatch(
    icdCodes,
    values.testTypeId == 8 && values.additionalCodes.length > 0
  );

  useEffect(() => {
    if (values.testTypeId == 8 && values.additionalCodes.length > 0) {
      refetch();
    }
  }, [values?.testTypeId, values?.additionalCodes?.length, refetch]);

  useEffect(() => {
    if (icd10CodeMismatch !== undefined) {
      if (icd10CodeMismatch) {
        toastMessages.warning(
          "Multiple ICD-10 codes have been selected for the same diagnosis. These diagnoses contradict each other in duration and/or intensity. Please revise"
        );
      }
      setFieldValue("icd10CodeMismatch", icd10CodeMismatch);
    }
  }, [icd10CodeMismatch, setFieldValue]);

  if (values.testTypeId === 8 && values.icd10CodeMismatch) {
    return (
      <WarningBanner warning="Multiple ICD-10 codes have been selected for the same diagnosis. These diagnoses contradict each other in duration and/or intensity. Please revise" />
    );
  }
  return <Fragment />;
}

export default IcdMismatchBanner;
